// Dependencies
import { createSlice } from '@reduxjs/toolkit';
import { PayloadAction } from '@reduxjs/toolkit/dist/createAction';
// Types
import { HomeState } from '../objects/homeState';
import { setEvent } from "../../event/redux/reducer";
import { utcToZonedTime } from "date-fns-tz";

const initialState: HomeState = {
    active_search_module: 'ACCOMMODATION'
};

export const homeSlice = createSlice({
    name: 'home',
    initialState,
    reducers: {
        updateActiveSearchModule: (state, action: PayloadAction<'FLIGHT' | 'ACCOMMODATION' | 'CAR' | 'ACCOMMODATION_FLIGHT'>) => {
            state.active_search_module = action.payload;
        }
    },
    extraReducers: builder => {
        builder.addCase(setEvent, (state, action) => {
            if (!action.payload.activated_module.includes(state.active_search_module)) {
                if (action.payload.activated_module.length > 0) {
                    state.active_search_module = action.payload.activated_module[0];
                }
            }
        });
    }
});

export const {
    updateActiveSearchModule
} = homeSlice.actions;

export default homeSlice.reducer;